import React from 'react';
import { TextInput } from '../../form/TextInput';
import { AddressFields } from '../../form/AddressFields';
import { YesNoInput } from '../../form/YesNoInput';
import { SelectInput } from '../../form/SelectInput';
import { TextAreaInput } from '../../form/TextAreaInput';
import * as Grid from '../../components/Grid';
import { Button } from '../../components/Button';
import { useHasMany } from './shared/useHasMany';
const DefaultAdditionalInsured = ({ defaultAdditionalInsured, states, }) => {
    const state = states.find((s) => s.id === defaultAdditionalInsured.address_attributes?.state_id);
    return (React.createElement(React.Fragment, null,
        React.createElement("p", null, "The following will automatically be issued as an additional insured:"),
        React.createElement("p", null, defaultAdditionalInsured.name),
        React.createElement("p", null,
            defaultAdditionalInsured.address_attributes?.address1,
            ",",
            ' ',
            defaultAdditionalInsured.address_attributes?.city,
            " ",
            state?.name,
            ' ',
            defaultAdditionalInsured.address_attributes?.zip)));
};
export const AdditionalInsureds = ({ orderId, defaultAdditionalInsured, additionalInsureds, onChange, states, errors, }) => {
    const onAdditionalInsuredChanges = (insureds) => {
        onChange({
            additional_insureds_attributes: insureds,
        });
    };
    const { onUpdate, onFieldUpdates, onAdd, onRemove, showRecords, setShowRecords, buildNewRecord, } = useHasMany({
        orderId,
        keyBase: 'insured',
        records: additionalInsureds,
        onChange: onAdditionalInsuredChanges,
    });
    React.useEffect(() => {
        if (showRecords == false) {
            onChange({
                has_additional_insureds: false,
                additional_insureds_attributes: additionalInsureds.map((ai) => {
                    return { ...ai, _destroy: true };
                }),
            });
        }
        else if (showRecords && additionalInsureds.length > 0) {
            onChange({ has_additional_insureds: true });
        }
        else if (showRecords && additionalInsureds.length === 0) {
            onChange({
                has_additional_insureds: true,
                additional_insureds_attributes: [buildNewRecord()],
            });
        }
    }, [showRecords]);
    return (React.createElement("fieldset", null,
        React.createElement("h2", null, "Additional Insured"),
        React.createElement("p", null, "Owners and/or Lessors of Premises and Organization Sponsors may be included as Additional Insureds. Additional Insured coverage will not apply to individuals or to entities that are not Owner/Lessors or Sponsors. If others require Additional Insured status contact us at (800)-727-7642 for assistance."),
        defaultAdditionalInsured && (React.createElement(DefaultAdditionalInsured, { defaultAdditionalInsured: defaultAdditionalInsured, states: states })),
        React.createElement(YesNoInput, { name: "additional_insureds_show_records", label: "Are you contractually required to name any other entity(s) as an Additional Insured?", value: showRecords, onChange: (v) => {
                setShowRecords(v);
            } }),
        showRecords && (React.createElement(React.Fragment, null,
            additionalInsureds
                .filter((r) => !r._destroy)
                .map((additionalInsured) => {
                const insuredKey = additionalInsured.id || additionalInsured.key || '';
                return (React.createElement("div", { key: insuredKey },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 6 },
                            React.createElement(TextInput, { label: "Name", id: `additional_insured_${insuredKey}_name`, required: true, value: additionalInsured.name, onChange: (v) => onUpdate(additionalInsured, 'name', v) })),
                        React.createElement(Grid.Column, { width: 6 },
                            React.createElement(SelectInput, { label: "Relationship", required: true, id: `additional_insured_${insuredKey}_relationship`, value: additionalInsured.relationship, onChange: (v) => onUpdate(additionalInsured, 'relationship', v), options: [
                                    'Owner or Lessor Of Premises',
                                    'Sponsor of Organization',
                                ].map((v) => {
                                    return { value: v, name: v };
                                }) }))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: 6 },
                            React.createElement(YesNoInput, { name: `additional_insured_${insuredKey}_special_wording_required`, label: "Does your contract require any other special wording on their certificate?", value: additionalInsured.special_wording_required, onChange: (v) => {
                                    onFieldUpdates(additionalInsured, {
                                        special_wording_required: v,
                                        special_wording: v
                                            ? additionalInsured.special_wording
                                            : null,
                                    });
                                } })),
                        React.createElement(Grid.Column, { width: 6 },
                            React.createElement(YesNoInput, { name: `additional_insured_${insuredKey}_waiver_of_subrogation_required`, label: "Does your contract require a Waiver of Subrogation Endorsement?", value: additionalInsured.waiver_of_subrogation_required, onChange: (v) => onUpdate(additionalInsured, 'waiver_of_subrogation_required', v) }))),
                    additionalInsured.special_wording_required && (React.createElement(TextAreaInput, { label: "Special Wording", id: `additional_insured_${insuredKey}_special_wording`, value: additionalInsured.special_wording, errors: [], required: true, onChange: (v) => onUpdate(additionalInsured, 'special_wording', v) })),
                    React.createElement(AddressFields, { idBase: `additional_insured_${insuredKey}_address`, onChange: (addr) => onUpdate(additionalInsured, 'address_attributes', addr), states: states, errors: [], address: additionalInsured.address_attributes || {} }),
                    React.createElement(Button, { testId: `remove-insured-${insuredKey}`, className: "button--small button--warning", onClick: () => onRemove(additionalInsured) }, "Remove Additional Insured")));
            }),
            React.createElement(Button, { onClick: onAdd },
                additionalInsureds.length > 0 ? 'Add Another' : 'Add',
                " Additional Insured"),
            React.createElement("div", { className: "input__error" }, errors
                .filter((e) => e.field.includes('organization_additional_insureds'))
                .map((e) => (React.createElement("p", { key: e.field },
                e.label,
                " - ",
                e.messages.join('; ')))))))));
};
